/* @flow */
import AdminSchoolSisSyncHeader from './AdminSchoolSisSyncHeader';

export default AdminSchoolSisSyncHeader;
